import { useId } from 'react';
import clsx from 'clsx';

import classes from './pulse-square-mark.module.css';

/** White halftone dots, from the 44×44 `logo_square.svg`. */
const PULSE_SQUARE_DOTS = [
  'M16.499 10.9499C17.2998 10.9499 17.949 10.3008 17.949 9.49995C17.949 8.69914 17.2998 8.04995 16.499 8.04995C15.6982 8.04995 15.049 8.69914 15.049 9.49995C15.049 10.3008 15.6982 10.9499 16.499 10.9499Z',
  'M21.499 10.9899C22.3219 10.9899 22.989 10.3229 22.989 9.49995C22.989 8.67704 22.3219 8.00995 21.499 8.00995C20.6761 8.00995 20.009 8.67704 20.009 9.49995C20.009 10.3229 20.6761 10.9899 21.499 10.9899Z',
  'M26.499 10.8599C27.2501 10.8599 27.859 10.2511 27.859 9.49995C27.859 8.74884 27.2501 8.13995 26.499 8.13995C25.7479 8.13995 25.139 8.74884 25.139 9.49995C25.139 10.2511 25.7479 10.8599 26.499 10.8599Z',
  'M11.499 16.0399C12.3495 16.0399 13.039 15.3505 13.039 14.4999C13.039 13.6494 12.3495 12.9599 11.499 12.9599C10.6485 12.9599 9.95898 13.6494 9.95898 14.4999C9.95898 15.3505 10.6485 16.0399 11.499 16.0399Z',
  'M16.499 16.3099C17.4986 16.3099 18.309 15.4996 18.309 14.4999C18.309 13.5003 17.4986 12.6899 16.499 12.6899C15.4993 12.6899 14.689 13.5003 14.689 14.4999C14.689 15.4996 15.4993 16.3099 16.499 16.3099Z',
  'M21.499 16.3799C22.5373 16.3799 23.379 15.5382 23.379 14.4999C23.379 13.4617 22.5373 12.6199 21.499 12.6199C20.4607 12.6199 19.619 13.4617 19.619 14.4999C19.619 15.5382 20.4607 16.3799 21.499 16.3799Z',
  'M26.499 16.1899C27.4323 16.1899 28.189 15.4333 28.189 14.4999C28.189 13.5666 27.4323 12.8099 26.499 12.8099C25.5656 12.8099 24.809 13.5666 24.809 14.4999C24.809 15.4333 25.5656 16.1899 26.499 16.1899Z',
  'M31.499 15.8599C32.2501 15.8599 32.859 15.2511 32.859 14.4999C32.859 13.7488 32.2501 13.1399 31.499 13.1399C30.7479 13.1399 30.139 13.7488 30.139 14.4999C30.139 15.2511 30.7479 15.8599 31.499 15.8599Z',
  'M11.499 21.04C12.3495 21.04 13.039 20.3505 13.039 19.5C13.039 18.6495 12.3495 17.96 11.499 17.96C10.6485 17.96 9.95898 18.6495 9.95898 19.5C9.95898 20.3505 10.6485 21.04 11.499 21.04Z',
  'M16.4988 21.3799C17.5371 21.3799 18.3788 20.5381 18.3788 19.4999C18.3788 18.4616 17.5371 17.6199 16.4988 17.6199C15.4606 17.6199 14.6188 18.4616 14.6188 19.4999C14.6188 20.5381 15.4606 21.3799 16.4988 21.3799Z',
  'M21.4993 21.3799C22.5376 21.3799 23.3793 20.5381 23.3793 19.4999C23.3793 18.4616 22.5376 17.6199 21.4993 17.6199C20.461 17.6199 19.6193 18.4616 19.6193 19.4999C19.6193 20.5381 20.461 21.3799 21.4993 21.3799Z',
  'M26.499 21.3799C27.5373 21.3799 28.379 20.5382 28.379 19.4999C28.379 18.4617 27.5373 17.6199 26.499 17.6199C25.4607 17.6199 24.619 18.4617 24.619 19.4999C24.619 20.5382 25.4607 21.3799 26.499 21.3799Z',
  'M31.499 20.9899C32.3219 20.9899 32.989 20.3229 32.989 19.4999C32.989 18.677 32.3219 18.0099 31.499 18.0099C30.6761 18.0099 30.009 18.677 30.009 19.4999C30.009 20.3229 30.6761 20.9899 31.499 20.9899Z',
  'M11.499 26.04C12.3496 26.04 13.039 25.3506 13.039 24.5C13.039 23.6495 12.3496 22.96 11.499 22.96C10.6485 22.96 9.95904 23.6495 9.95904 24.5C9.95904 25.3506 10.6485 26.04 11.499 26.04Z',
  'M16.4992 26.38C17.5375 26.38 18.3792 25.5383 18.3792 24.5C18.3792 23.4617 17.5375 22.62 16.4992 22.62C15.4609 22.62 14.6192 23.4617 14.6192 24.5C14.6192 25.5383 15.4609 26.38 16.4992 26.38Z',
  'M21.4988 26.3799C22.5371 26.3799 23.3788 25.5381 23.3788 24.4999C23.3788 23.4616 22.5371 22.6199 21.4988 22.6199C20.4606 22.6199 19.6188 23.4616 19.6188 24.4999C19.6188 25.5381 20.4606 26.3799 21.4988 26.3799Z',
  'M26.4991 26.1999C27.438 26.1999 28.1991 25.4388 28.1991 24.4999C28.1991 23.561 27.438 22.7999 26.4991 22.7999C25.5602 22.7999 24.7991 23.561 24.7991 24.4999C24.7991 25.4388 25.5602 26.1999 26.4991 26.1999Z',
  'M31.499 25.45C32.0237 25.45 32.449 25.0247 32.449 24.5C32.449 23.9753 32.0237 23.55 31.499 23.55C30.9743 23.55 30.549 23.9753 30.549 24.5C30.549 25.0247 30.9743 25.45 31.499 25.45Z',
  'M11.499 30.9099C12.2777 30.9099 12.909 30.2787 12.909 29.4999C12.909 28.7212 12.2777 28.0899 11.499 28.0899C10.7203 28.0899 10.089 28.7212 10.089 29.4999C10.089 30.2787 10.7203 30.9099 11.499 30.9099Z',
  'M16.499 31.1399C17.4047 31.1399 18.139 30.4057 18.139 29.4999C18.139 28.5942 17.4047 27.8599 16.499 27.8599C15.5932 27.8599 14.859 28.5942 14.859 29.4999C14.859 30.4057 15.5932 31.1399 16.499 31.1399Z',
  'M21.4991 30.9101C22.2778 30.9101 22.9091 30.2788 22.9091 29.5001C22.9091 28.7214 22.2778 28.0901 21.4991 28.0901C20.7204 28.0901 20.0891 28.7214 20.0891 29.5001C20.0891 30.2788 20.7204 30.9101 21.4991 30.9101Z',
  'M26.4991 30.4498C27.0238 30.4498 27.4491 30.0245 27.4491 29.4998C27.4491 28.9752 27.0238 28.5498 26.4991 28.5498C25.9744 28.5498 25.5491 28.9752 25.5491 29.4998C25.5491 30.0245 25.9744 30.4498 26.4991 30.4498Z',
  'M16.6504 35.7598C17.3463 35.7598 17.9104 35.1957 17.9104 34.4998C17.9104 33.804 17.3463 33.2398 16.6504 33.2398C15.9546 33.2398 15.3904 33.804 15.3904 34.4998C15.3904 35.1957 15.9546 35.7598 16.6504 35.7598Z',
  'M11.6591 35.7599C12.355 35.7599 12.9191 35.1958 12.9191 34.4999C12.9191 33.8041 12.355 33.2399 11.6591 33.2399C10.9632 33.2399 10.3991 33.8041 10.3991 34.4999C10.3991 35.1958 10.9632 35.7599 11.6591 35.7599Z',
  'M21.4993 35.6C22.1068 35.6 22.5993 35.1075 22.5993 34.5C22.5993 33.8925 22.1068 33.4 21.4993 33.4C20.8918 33.4 20.3993 33.8925 20.3993 34.5C20.3993 35.1075 20.8918 35.6 21.4993 35.6Z',
] as const;

/** Radial glows behind the dots, each fading from `color` to transparent, from the design vector. */
const GLOWS = [
  { cx: 43.5, cy: 0.500061, r: 43.5, color: '#6367DE', drift: 'purple' },
  { cx: 0, cy: 22.0001, r: 44, color: '#FBAF05', drift: 'orange' },
  { cx: 0.5, cy: 43.5, r: 43.5, color: '#F9477A', drift: 'pink' },
  { cx: 44.8335, cy: 28.834, r: 44.4158, color: '#65B7CE', drift: 'blue', rotate: 0.54206 },
] as const;

interface PulseSquareMarkProps {
  /** Drift the four glows (`logo_square_animated.svg`). Still under reduced motion. */
  animated?: boolean;
  /** Edge length in px of the square mark. */
  size?: number;
}

/**
 * The Pulse app tile (`logo_square.svg`): white halftone dots on a rounded square with a
 * four-color glow, drawn on a 44×44 grid and scaled to `size` px square.
 */
export const PulseSquareMark = ({ animated = false, size = 44 }: PulseSquareMarkProps) => {
  const uid = useId();
  const maskId = `${uid}-mask`;
  const glowId = (index: number) => `${uid}-glow-${index}`;

  return (
    <svg
      aria-hidden
      fill="none"
      height={size}
      viewBox="0 0 44 44"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id={maskId}
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        x="0"
        y="0"
        width="44"
        height="44"
      >
        <path
          d="M0 8C0 3.58172 3.58172 0 8 0H36C40.4183 0 44 3.58172 44 8V36C44 40.4183 40.4183 44 36 44H8C3.58172 44 0 40.4183 0 36V8Z"
          fill="#D9D9D9"
        />
      </mask>
      <g mask={`url(#${maskId})`}>
        <circle cx="21.5" cy="22.5001" r="42.5" fill="#FFAF00" />
        {GLOWS.map((glow, index) => (
          <g
            key={glow.color}
            className={animated ? clsx(classes.blob, classes[glow.drift]) : undefined}
          >
            <circle
              cx={glow.cx}
              cy={glow.cy}
              r={glow.r}
              fill={`url(#${glowId(index)})`}
              transform={
                'rotate' in glow ? `rotate(${glow.rotate} ${glow.cx} ${glow.cy})` : undefined
              }
            />
          </g>
        ))}
      </g>
      {PULSE_SQUARE_DOTS.map((d) => (
        <path key={d} d={d} fill="white" />
      ))}
      <defs>
        {GLOWS.map((glow, index) => (
          <radialGradient
            key={glow.color}
            id={glowId(index)}
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform={`translate(${glow.cx} ${glow.cy}) rotate(90) scale(${glow.r})`}
          >
            <stop stopColor={glow.color} />
            <stop offset="1" stopColor={glow.color} stopOpacity="0" />
          </radialGradient>
        ))}
      </defs>
    </svg>
  );
};
